import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-mail',
  name: 'Access Mail',
  category: 'access-integrations',
  description: 'Send emails using the Access internal mail service. No credential setup required - uses system-managed SendGrid account.',
  icon: 'Mail',
  color: 'blue',
  version: '1.0.0',

  defaults: {
    name: 'Access Mail',
    color: '#1a82e2'
  },

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['access', 'email', 'send', 'mail', 'internal'],
};

export default definition;
